/** @jsx jsx */
import { jsx } from '@emotion/core';
import { gridSize } from '@atlaskit/theme/constants';

var NavigationHeader = function NavigationHeader(props) {
  var children = props.children;
  return jsx("div", {
    "data-navheader": true,
    css: {
      paddingTop: gridSize() * 3,
      paddingBottom: gridSize(),
      paddingLeft: gridSize(),
      paddingRight: gridSize()
    }
  }, children);
};

export default NavigationHeader;